import { get } from '../actions/method';

export async function getGroups() {
  return await get('app/groups?Sorting=name%20asc&MaxResultCount=1000');
}
export async function getGroupDetail(groupId) {
  return get(`app/groups/${groupId}`)
    .then((resp) => resp)
    .catch((err) => {
      throw err;
    });
}
